// Admin Imports
import Home from "views/home";
import Transactions from "views/txs";
import TransactionDetails from "views/txs/detail";
import Blocks from "views/blocks";
import BlockDetails from "views/blocks/[block]/detail";
import AccountsBalance from "views/accounts";
import Address from "views/accounts/address";
import Portfolio from "views/accounts/portfolio";
import NetworkStatus from "views/status";
import Settings from "views/footer/settings";
import TermsOfService from "views/footer/terms";
import PrivacyPolicy from "views/footer/policy";
import ContactUs from "views/footer/contact";
import Feedback from "views/footer/feedback";
import Nft from "views/nft";
import NftDetails from "views/nft/detail";
import NftCollection from "views/nft/collection";
import Leaderboard from "views/leaderboard";
import TokenInfo from "views/leaderboard/token";
import DexTracker from "views/leaderboard/dex";
import Trades from "views/nft/trades";
import Transfers from "views/nft/transfers";

// Auth Imports
import Login from "views/auth/login";
import Register from "views/auth/register";

// Icon Imports
import { MdHome } from "react-icons/md";

const routes = [
  {
    name: "Home",
    layout: "",
    path: "",
    icon: <MdHome className="h-6 w-6" />,
    component: <Home />,
  },
  {
    name: "Transactions",
    layout: "",
    path: "txs",
    icon: <MdHome className="h-6 w-6" />,
    component: <Transactions />,
  },
  {
    name: "Transaction Details",
    layout: "",
    path: "/tx/:signature",
    icon: <MdHome className="h-6 w-6" />,
    component: <TransactionDetails />,
  },
  {
    name: "Blocks",
    layout: "",
    path: "blocks",
    icon: <MdHome className="h-6 w-6" />,
    component: <Blocks />,
  },
  {
    name: "NFTs",
    layout: "",
    path: "nfts",
    icon: <MdHome className="h-6 w-6" />,
    component: <Nft />,
  },
  {
    name: "Trades",
    layout: "",
    path: "trades",
    icon: <MdHome className="h-6 w-6" />,
    component: <Trades />,
  },
  {
    name: "Transfers",
    layout: "",
    path: "transfers",
    icon: <MdHome className="h-6 w-6" />,
    component: <Transfers />,
  },
  {
    name: "NFT Details",
    layout: "",
    path: "collection/*",
    icon: <MdHome className="h-6 w-6" />,
    component: <NftCollection />,
  },
  {
    name: "NFT Details",
    layout: "",
    path: "nft/*",
    icon: <MdHome className="h-6 w-6" />,
    component: <NftDetails />,
  },
  {
    name: "Leaderboard",
    layout: "",
    path: "tokens",
    icon: <MdHome className="h-6 w-6" />,
    component: <Leaderboard />,
  },
  {
    name: "Token Info",
    layout: "",
    path: "token/*",
    icon: <MdHome className="h-6 w-6" />,
    component: <TokenInfo />,
  },
  {
    name: "Token Info",
    layout: "",
    path: "dex/*",
    icon: <MdHome className="h-6 w-6" />,
    component: <DexTracker />,
  },
  {
    name: "Block Details",
    layout: "",
    path: "/block/:height",
    icon: <MdHome className="h-6 w-6" />,
    component: <BlockDetails />,
  },
  {
    name: "Accounts Balance",
    layout: "",
    path: "accounts",
    icon: <MdHome className="h-6 w-6" />,
    component: <AccountsBalance />,
  },
  {
    name: "Address",
    layout: "",
    path: "address/*",
    icon: <MdHome className="h-6 w-6" />,
    component: <Address />,
  },
  {
    name: "Portfolio",
    layout: "",
    path: "portfolio/*",
    icon: <MdHome className="h-6 w-6" />,
    component: <Portfolio />,
  },
  {
    name: "Network Status",
    layout: "",
    path: "status",
    icon: <MdHome className="h-6 w-6" />,
    component: <NetworkStatus />,
  },
  {
    name: "Network Status",
    layout: "",
    path: "login",
    icon: <MdHome className="h-6 w-6" />,
    component: <Login />,
  },
  {
    name: "Network Status",
    layout: "",
    path: "register",
    icon: <MdHome className="h-6 w-6" />,
    component: <Register />,
  },
  {
    name: "Settings",
    layout: "",
    path: "settings",
    icon: <MdHome className="h-6 w-6" />,
    component: <Settings />,
  },
  {
    name: "Terms of Service",
    layout: "",
    path: "/terms-of-service",
    icon: <MdHome className="h-6 w-6" />,
    component: <TermsOfService />,
  },
  {
    name: "Privacy Policy",
    layout: "",
    path: "/privacy-policy",
    icon: <MdHome className="h-6 w-6" />,
    component: <PrivacyPolicy />,
  },
  {
    name: "Contact Us",
    layout: "",
    path: "contact",
    icon: <MdHome className="h-6 w-6" />,
    component: <ContactUs />,
  },
  {
    name: "Feedback",
    layout: "",
    path: "contact/feedback",
    icon: <MdHome className="h-6 w-6" />,
    component: <Feedback />,
  },
];
export default routes;
